/**
 * Port of extension/src/adapters/dom/dictationStyleSource.cjs
 * Prefer painted cue node so the dictation input inherits subtitle look.
 */

export function resolveDictationStyleSource(
  container: ParentNode | null | undefined,
): HTMLElement | null {
  if (!container || typeof (container as Element).querySelector !== 'function') {
    return null;
  }
  const el = container as Element;
  return (
    (el.querySelector('.textBasedSub') as HTMLElement | null)
    || (el.querySelector('.hContainer') as HTMLElement | null)
    || (el.querySelector('.vContainer') as HTMLElement | null)
    || null
  );
}

export function applyDictationInputAppearance(
  input: HTMLElement,
  styleSource: HTMLElement | null | undefined,
): void {
  if (!input || !styleSource) return;
  input.style.backgroundColor = styleSource.style.backgroundColor;
  input.style.color = styleSource.style.color;
  input.style.fontSize = styleSource.style.fontSize;
}
